import React, { createContext, useContext } from "react";
import { useAsync } from "react-async";
import { AxiosUserAPI } from "../common/Api";

const useCurrentUser = () => {
  const { data, error, isPending, reload } = useAsync({
    promiseFn: AxiosUserAPI.getCurrent,
  });

  return { user: data, isPending, error, reload };
};

// From https://usehooks.com/useAuth/
const authContext = createContext();

export function AuthProvider({ children }) {
  const auth = useCurrentUser();
  return <authContext.Provider value={auth}>{children}</authContext.Provider>;
}

export const useAuth = () => {
  return useContext(authContext);
};

export const userActiveView = (user) => {
  return user.active_employee
    ? user.active_employee._extra.is_superuser
    : user.is_superuser;
};
